import Resources from "shared/actions/resourcesActions";

export default class AttachmentsResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "attachment", `/api/v1/messaging/attachments`);
  }
}
